"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatOutlinedIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Chat Outlined Icon
 * See: https://www.figma.com/file/QX7PBRvpCkgeJ2lusfPr1v/Indicators-%26-Upsells?node-id=6997%3A83896
 */
function ChatOutlinedIcon(props) {
    switch (props.size) {
        // TODO: add different sizes.
        default:
            return (0, jsx_runtime_1.jsx)(ReactBasedChatOutlineIcon, {});
    }
}
exports.ChatOutlinedIcon = ChatOutlinedIcon;
// SVG code copied from Chatoutline Icon(./Medium.svg)
function ReactBasedChatOutlineIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: 16, height: 18, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.622 13.356 14 14.954V3.839C14 2.9 13.183 2 12 2H4c-1.183 0-2 .9-2 1.839v7.678c0 .939.817 1.839 2 1.839h7.622Zm4.235 2.845h-.002Zm-4.845-.845 3.73 2.505c.134.09.294.139.458.139.442 0 .8-.344.8-.768V3.84C16 1.719 14.21 0 12 0H4C1.79 0 0 1.719 0 3.839v7.678c0 2.12 1.79 3.839 4 3.839h7.012Z", fill: "#FFFC00" }) }));
}
//# sourceMappingURL=ChatOutlinedIcon.js.map